import { getEditLocation } from "../../../core/util/functions";
export const invoicesLocation = "/accounting/invoices";
export const getInvoicesEditLocation = (id?: string) =>
  getEditLocation(invoicesLocation, undefined, id);

export const editRouter = getInvoicesEditLocation(":invId?");
